<ng-container *ngIf="gitlabIssues.length === 0">
  <p [innerHTML]="getEmptyText()"></p>
</ng-container>

<gitlab-issue [gitlabIssue]="gitlabIssue" *ngFor="let gitlabIssue of gitlabIssues"></gitlab-issue>
